export default {
  //代码里的key(唯一标识): '繁体中文',
  lang: 'zh_TW',
  appIntroduction: '熱門 Movie & Drama 隨時免費看',
  noMoreTip: '你已經刷到底了,沒有更多內容了~',
  navigator: {
    home: '首頁',
    all: '所有內容',
    news: '文章資訊',
    download: '下載APP',
    contact: '關於我們',
    joinUs: '加入我們'
  },
  seo: {
    title: 'Loklok-全球高清視頻免費在線觀看',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie, 電影,電視劇,韓劇,動漫,甜寵劇,美劇,流媒體,幸福,海賊王,單身即地獄,哈利比特,泰版流星花園,精靈旅社,歡樂好聲音,國王排名,咒術回戰,進擊的巨人,魷魚游戲,寂靜之海等',
    description: '熱門劇集急速更新,美國電影大片,懸疑,喜劇,戀愛韓劇,驚悚,綜藝都在Loklok,高清畫面,多語言字幕免費在線觀看。',
    ogImage: 'https://static.loklok.video/img/tw-tw.png',
    index: {
      title: 'Loklok-全球高清視頻免費在線觀看-海量熱門劇集、高分電影推薦',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, 韓劇,美劇,泰劇,電影,電視劇,動漫,綜藝,bl,gl,好萊塢,喪屍, 禁忌之戀,love affair, all of us are dead',
      description: 'loklok是聚集全球熱門高分電視劇、電影、動漫的視頻內容平台。擁有超多海外精品劇集、熱門爆款電影,多種字幕可供選擇,影視資源豐富,超高清HD 4k畫質,熱門新片全網首發！ '
    },
    allPage: {
      title: 'Loklok-全球高清視頻免費在線觀看- 電影,劇集,動漫,美劇,泰劇,韓劇,日劇應有盡有',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,  animation,anime,blockbuster movies,new episode,2022 new release,premiere,sci-fi,sweet romance,comedy,action,love,殭屍校園,泰版流星花園,亢奮 第二季,二十五 二十一,氣象廳的人們,幽靈醫生,女神降臨,魔法滿屋,夢魘絕鎮,社內相親,雪滴花,你和我的警察課堂,假偶天成',
      description: 'loklok擁有海量爆款影視內容,時下最新最熱電視劇電影免費看！多元化的高清內容、個性化的用戶體驗,熱門影視應有盡有。熱門最新電影、超高清HD、4K上映電影、喜劇、美劇、多種字幕可供選擇。'
    },
    articles: {
      title: 'loklok news - 最新最熱影視資訊、熱門影評、最值得看的全球好片大搜羅,你想了解的影視信息每日放送！ ',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, 最新影視資訊,影片推薦,熱門影評,2022影視,新片首發,2022值得觀看,2022院線電影,2023值得期待的電影, 浴血黑幫 第六季,進擊的巨人 最終季,那年,我們的夏天,精靈旅社4：變身大冒險,幸福',
      description: 'loklok熱門影視內容即搜即得,各類電影電視劇排行榜24h即時更新,熱門影視內容實時呈現,劇荒就來loklok,最新熱門電影資訊,熱門影評,最新電視劇影評'
    },
    download: {
      title: 'loklok提供官方最新版本的Google play下載、App Store下載、apk下載、各大應用商店下載,極速安裝,在loklok手機端免費在線觀看視頻',
      keywords: 'Loklok, Loklok app, loklok 下載, loklok pc, loklok apk, loklok 下載,下載 loklok,  loklok 下載 apk, loklok ios 下載, loklok android 下載, loklok googleplay, loklok pc 下載, loklok 最新版, loklok 官網, how to 下載 Loklok, Loklok 桌面端, Loklok pad',
      description: '下載loklok app,可免費在線觀看極速高清最新海內外電影、電視劇。下載最新版本loklok app,可下載安裝後通過手機端掃描網站二維碼,pc端同時在線播放。 '
    },
    search: {
      title: 'loklok - 找到你喜歡的視頻資源',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,找劇,搜索劇集,熱門劇集榜單,電影榜,美劇榜,泰劇榜,韓劇榜,電影 top10,劇集top10, 2022影視 top100,2021影視 top100',
      description: 'loklok根據觀看、搜索熱度每日實時更新推薦最受歡迎的全球熱門劇集、電影等,解決劇荒煩惱,提升觀看體驗'
    },
    contact: {

    }
  },
  globalTip: {
    emptyTip: '找不到資源',
    searchOther: '嘗試搜索其他內容'
  },
  loginModule: {
    title: '登錄',
    loginMethod: '使用loklok APP掃描二維碼',
    loginMethodTip: '（版本需升級至1.7.0及以上）',
    howToDownload: '如何下載loklok',
    clickMe: '點我',
    loginSuccess: '登錄成功',
    loginFailed: '登錄失敗',
    codeExpired: '二維碼過期了！ ',
    refreshButton: '刷新',
    loginButton: '登錄',
    loginTip: '登錄後免費觀看全站內容',
    logoutButton: '退出登錄',
    logoutTip: '享受觀影吧！ ',
    areYouSure: '確定要退出登錄嗎？ ',
    sure: '確定',
    cancel: '取消'
  },
  toTop: {
    downloadApp: '下載 App',
    backToTop: '返回頂部'
  },
  indexPage: {
    title: 'LolokTV',
    more: '更多',
    seeMore: '查看更多'
  },
  searchPage: {
    resultTitle: '搜索到以下內容：',
    rank: 'Loklok熱搜榜',
    play: '播放',
    popularSearch: '熱門搜索',
    top1: '第1名',
    top2: '第2名',
    top3: '第3名',
    top4: '第4名',
    top5: '第5名',
    top6: '第6名',
    top7: '第7名',
    top8: '第8名',
    top9: '第9名',
    top10: '第10名',
    emptyTip: '抱歉,我們沒有那個內容',
    emptyDesc: '試試搜索其他電影或電視劇'
  },
  filterPage: {
    emptyTip: '抱歉,我們沒有那個內容',
    emptyDesc: '試試搜索其他電影或電視劇'
  },
  newsPage: {
    listTitle: '最新資訊'
  },
  downloadPage: {
    scanQR: '掃碼下載APP',
    title1: '熱門Movie&Drama',
    tip1: '隨時免費看',
    title2: '多語言字幕',
    tip2: '輕鬆看劇',
    title3: 'PC/手機實時同步'
  },
  detailPage: {
    autoTranslation: '自動翻譯',
    fiveMiniteTip: '只能看5分鐘，看完整片',
    loginTip2InDetailPage: '使用loklok APP掃描下方二維碼,完成登錄後觀看剩餘內容',
    category: '分類',
    moreDesc: '更多',
    youMayLike: '猜你喜歡',
    relatedSeries: '相關係列',
    norelatedSeries: '沒有相關係列',
    emptyDesc: '抱歉,我們沒有那個內容',
    emptyTip: '抱歉,我們沒有那個內容',
    vip: {
      dialog: {
        t1: '開通VIP',
        t2: '如需查看全部內容，請至App內開通VIP',
        t3: '可通過以下方式下載App',
        t4: '已有VIP？請<span class="active">點擊此處</span>登錄',
        t5: '已有VIP？請<span class="active">刷新</span>後繼續觀看',
        t6: '您已觀看{num}分鐘，若想繼續觀看完整影片，請前往App，或在App內開通VIP後，您可以繼續瀏覽該影片'
      },
      player: {
        tip1: '只能觀看{num}分鐘，觀看全片<span class="active">請至App內</span>或<span class="active">開通VIP</span>'
      },
      episodes: {
        tip1: '成為VIP，暢享全部內容'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: '瀏覽器正在下載數據',
    NETWORK_NO_SOURCE: '未找到音頻/視頻來源',
    MEDIA_ERR_ABORTED: '取回過程被用戶中止',
    MEDIA_ERR_NETWORK: '當下載時發生錯誤',
    MEDIA_ERR_DECODE: '播放解析失敗：無法播放文件',
    MEDIA_ERR_SRC_NOT_SUPPORTED: '不支持的音頻/視頻格式',
    REPLAY: '重播',
    ERROR: '網絡連接似乎出現了問題',
    PLAY_TIPS: '播放',
    PAUSE_TIPS: '暫停',
    PLAYNEXT_TIPS: '下一集',
    DOWNLOAD_TIPS: '下載',
    ROTATE_TIPS: '旋轉',
    RELOAD_TIPS: '重新載入',
    FULLSCREEN_TIPS: '進入全屏',
    EXITFULLSCREEN_TIPS: '退出全屏',
    CSSFULLSCREEN_TIPS: '進入樣式全屏',
    EXITCSSFULLSCREEN_TIPS: '退出樣式全屏',
    TEXTTRACK: '字幕',
    PIP: '畫中畫',
    MINIPLAYER: '迷你播放器',
    SCREENSHOT: '截圖',
    LIVE: '正在直播',
    OFF: '關閉',
    MINIPLAYER_DRAG: '點擊按住可拖動視頻',
    AIRPLAY_TIPS: '隔空播放',
    onlyPlayTip: '只播放 {msg} 分鐘,登錄看全片',
    loginTextButton: '登錄',
    replayButton: '重播',
    nextButton: '下一集',
    refreshButton: '刷新',
    episode: '集'
  },
  contact: {
    business: '商務合作',
    question: '問題反饋'
  },
  download_nd: {
    desc: '海量影視劇免費看',
    scanQR: '掃描二維碼下載APP或者'
  },
  win: {
    feedback: {

    }
  },
  tv: {
    vip: {

    }
  }
}